"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _HoverTooltip = require('web/components/Tooltip/HoverTooltip'); var _HoverTooltip2 = _interopRequireDefault(_HoverTooltip);
var _ClickTooltip = require('web/components/Tooltip/ClickTooltip'); var _ClickTooltip2 = _interopRequireDefault(_ClickTooltip);
var _ControlledTooltip = require('web/components/Tooltip/ControlledTooltip'); var _ControlledTooltip2 = _interopRequireDefault(_ControlledTooltip);







var _TooltipElements = require('web/components/Tooltip/TooltipElements');







const isInTooltipContainer = (start) => {
  let node = start
  while (node !== document) { /* detect if click is on tooltip to prevent the two from interacting */
    // SAFETY: every ancestor below `document` is an Element, as the JS assumed.
    if ((node ).classList.contains('blm-tooltip--container')) {
      return true
    }
    // SAFETY: as in the JS, a node detached from the document throws here.
    node = node.parentNode 
  }
  return false
}

// TODO: Investigate. Seems to be unused.
Element.prototype.isInTooltip = function () {
  return isInTooltipContainer(this)
}












exports.TooltipItem = _TooltipElements.TooltipItem; exports.TooltipHint = _TooltipElements.TooltipHint; exports.TooltipInfo = _TooltipElements.TooltipInfo; exports.TooltipTitle = _TooltipElements.TooltipTitle; exports.TooltipContent = _TooltipElements.TooltipContent; exports.TooltipMenuItem = _TooltipElements.TooltipMenuItem; exports.ClickTooltip = _ClickTooltip2.default; exports.HoverTooltip = _HoverTooltip2.default; exports.ControlledTooltip = _ControlledTooltip2.default;
